import React from "react";
import FooterSection from "./FooterSection";

const ContactPage = () => {
  return (
    <>
  <section className="w-full pt-[100px] px-4 sm:px-6 font-inter md:pl-[200px] scale-100 md:scale-[0.95] bg-transparent">
        {/* Top Label */}
        <div className="max-w-[1100px] mx-auto">
          <div className="flex items-center justify-center gap-2 mb-3 ml-[10px] mr-[10px] border border-dashed border-neutral-300 shadow-sm h-[35px] w-[110px] mx-auto rounded-[40px] bg-white">
            <svg
              width="10"
              height="10"
              viewBox="0 0 256 256"
              fill="#3C5DF7"
              className="animate-spin"
              style={{ animationDuration: "5s" }}
            >
              <path d="M240,128a15.79,15.79,0,0,1-10.5,15l-63.44,23.07L143,229.5a16,16,0,0,1-30,0L89.94,166.06,26.5,143a16,16,0,0,1,0-30L89.94,89.94,113,26.5a16,16,0,0,1,30,0l23.07,63.44L229.5,113A15.79,15.79,0,0,1,240,128Z" />
            </svg>
            <span className="text-black font-medium text-[15px]">Contact</span>
          </div>

          {/* Heading */}
          <h1 className="text-[48px] md:text-[60px] font-semibold leading-[1.05] text-left tracking-tight">
              Book Your <span className="text-[#3C5DF7]" style={{fontFamily: "recoleta"}}>Call</span>  
          </h1>

          <p className="text-left text-[15.5px] text-[#555] max-w-[420px] mt-[10px] mb-[47px] leading-[1.6] font-[600] mx-0">
            Pick a date and time that works best for you.  
            No forms <br /> just a simple, clean booking experience.
          </p>

          {/* GOOGLE BOOKING CALENDAR */}
          <div
            className="
              mt-14 p-6 
              rounded-[22px]
              border border-dashed border-gray-300 
              bg-white 
              shadow-sm
              max-w-[950px]
              mb-[250px]
            "
          >
            <iframe
              src="https://calendar.app.google/wV4FfBWo7VHBWbzv7"
              style={{
                border: '0',
                width: '100%',
                height: '1000px',
                borderRadius: '18px',
              }}
              frameBorder="0"
            ></iframe>

            <p className="text-center text-gray-500 text-[14px] mt-4">
              Select a date to book your appointment.
            </p>
          </div>
        </div>
      </section>

      <FooterSection />
    </>
  );
};

export default ContactPage;
